/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teal_Wry_Horse_PlanInputs */

const en_teal_wry_horse_plan = /** @type {(inputs: Teal_Wry_Horse_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage the user's contact information and login details`)
};

const de_teal_wry_horse_plan = /** @type {(inputs: Teal_Wry_Horse_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten Sie die Kontaktdaten und Login-Informationen des Benutzers`)
};

/**
* | output |
* | --- |
* | "Manage the user's contact information and login details" |
*
* @param {Teal_Wry_Horse_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teal_wry_horse_plan = /** @type {((inputs?: Teal_Wry_Horse_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teal_Wry_Horse_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_teal_wry_horse_plan(inputs)
	return de_teal_wry_horse_plan(inputs)
});